// Chọn khoảng giá sỉ theo số lượng: khoảng cuối cùng có minQuantity <= quantity <= maxQuantity
// (maxQuantity null = không giới hạn trên). Không khớp → null (dùng giá bán lẻ).
export const findRangePrice = (ranges, quantity) => {
    let found = null;
    (ranges || []).forEach(item => {
        if (item.minQuantity <= quantity && (item.maxQuantity == null || item.maxQuantity >= quantity)) {
            found = item;
        }
    });
    return found;
};

// Áp giá sỉ cho danh sách dòng hàng, giống server khi tạo đơn: số lượng cộng theo sản phẩm (mọi phân loại trong danh sách).
// Dòng khớp khoảng → bản sao với đơn giá mới (setPrice), không khớp → giữ nguyên dòng.
export const withRangePrice = (items, productIdOf, rangesOf, setPrice) => {
    return (items || []).map(item => {
        const quantity = items
            .filter(x => productIdOf(x) === productIdOf(item))
            .reduce((sum, x) => sum + (parseInt(x?.quantity) || 0), 0);
        const range = findRangePrice(rangesOf(item), quantity);
        return range ? setPrice(item, range.price) : item;
    });
};

// Dòng giỏ hàng / thanh toán (ItemProductCart): {products, productSimilar, productRangePrice, quantity}
export const withCartRangePrice = (items) => withRangePrice(
    items,
    item => item?.products?.id,
    item => item?.productRangePrice,
    (item, price) => ({...item, productSimilar: {...item.productSimilar, price}})
);
